/**
 * FontAwesome 6 icons (fa-solid prefix)
 */
export const FONTAWESOME_ICONS = [
  // Fantasy/RPG
  'fa-dragon',
  'fa-dungeon',
  'fa-hat-wizard',
  'fa-wand-magic-sparkles',
  'fa-shield-halved',
  'fa-chess-rook',
  'fa-dice-d20',
  'fa-scroll',
  'fa-khanda',
  'fa-hand-fist',
  'fa-skull-crossbones',
  'fa-ghost',
  // People
  'fa-user',
  'fa-users',
  'fa-user-group',
  'fa-person',
  'fa-children',
  // Objects
  'fa-book',
  'fa-book-open',
  'fa-feather',
  'fa-key',
  'fa-lock',
  'fa-coins',
  'fa-gem',
  'fa-crown',
  'fa-ring',
  'fa-flask',
  // Locations
  'fa-map',
  'fa-location-dot',
  'fa-compass',
  'fa-mountain',
  'fa-tree',
  'fa-house',
  'fa-building',
  'fa-church',
  'fa-landmark',
  'fa-tent',
  // Elements
  'fa-fire',
  'fa-water',
  'fa-wind',
  'fa-snowflake',
  'fa-bolt',
  'fa-sun',
  'fa-moon',
  'fa-star',
  'fa-cloud',
  'fa-meteor',
  // Status
  'fa-heart',
  'fa-skull',
  'fa-cross',
  'fa-check',
  'fa-xmark',
  'fa-circle-info',
  'fa-triangle-exclamation',
  'fa-circle-question'
]

export default FONTAWESOME_ICONS
